import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/bookmark-edit-grey.svg'
import _imports_1 from '@/assets/icons/bookmark-edit-white.svg'
import _imports_2 from '@/assets/icons/delete-button-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-5afac356"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popup-container"
}
const _hoisted_2 = { class: "container d-flex flex-column h-100" }
const _hoisted_3 = { class: "row flex-grow-0" }
const _hoisted_4 = { class: "col-11 d-flex flex-column align-items-start justify-content-center" }
const _hoisted_5 = { class: "d-flex align-items-center gap-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "building-icon"
}, null, -1))
const _hoisted_7 = { class: "popup-title-text" }
const _hoisted_8 = { class: "col-1" }
const _hoisted_9 = { class: "drawer-content" }
const _hoisted_10 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_11 = { class: "mt-3 mb-3" }
const _hoisted_12 = ["disabled", "placeholder"]
const _hoisted_13 = {
  key: 0,
  class: "agencies-list"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "pagination-container" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "page-info" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "actions-container mt-3" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_24 = ["disabled"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "",
  class: "delete-icon"
}, null, -1))

import { businessService, queueService } from "@/_services";
import {
  ref,
  onMounted,
  computed,
  watch,
  nextTick,
} from "vue";
import { useI18n } from "vue-i18n";
import LbrxErrorNotification from "./LbrxErrorNotification.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'LbrxServicesDrawer',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
  services: {
    type: Array,
    required: true,
  },
  queue_id: {
    type: String,
    required: true,
  },
  ticket_id: {
    type: String,
    required: true,
  },
  ticket_services: {
    type: Array,
    required: true,
  },
},
  emits: ["close", "loading", "showNotification", "reload"],
  setup(__props, { emit }) {

const props = __props;

_useCssVars(_ctx => ({
  "3904db42": (_unref(FixBoxWidth))
}))

const { t } = useI18n();




const showPopup = ref(false);

const closeThis = () => {
  showPopup.value = false;
  setTimeout(() => {
    emit("close");
  }, 700);
};

const searchQuery = ref("");
const selectedServices: any = ref<Array<any>>([]);
const currentPage = ref(1);
const itemsPerPage = 10;

const filteredServices = computed(() => {
  if (!props.services || !Array.isArray(props.services)) return [];
  if (!searchQuery.value) return props.services;

  return props.services.filter(
    (service: any) =>
      service &&
      service.title &&
      service.title.toLowerCase().includes(searchQuery.value.toLowerCase())
  );
});

const paginatedServices = computed(() => {
  if (!filteredServices.value || !Array.isArray(filteredServices.value))
    return [];
  const startIndex = (currentPage.value - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  return filteredServices.value.slice(startIndex, endIndex);
});

const totalPages = computed(() => {
  if (!filteredServices.value || !Array.isArray(filteredServices.value))
    return 0;
  return Math.ceil(filteredServices.value.length / itemsPerPage);
});

const extractServiceId = (item: any): string | number | null => {
  if (item === null || item === undefined) return null;
  if (typeof item === "object") {
    if (Object.prototype.hasOwnProperty.call(item, "service_id"))
      return item.service_id;
    if (Object.prototype.hasOwnProperty.call(item, "id")) return item.id;
  }
  if (typeof item === "string" || typeof item === "number") return item;
  return null;
};

const initializeSelectionFromTicket = () => {
  console.log("ticket services in drawer", props.ticket_services);
  try {
    const ids = new Set(
      (Array.isArray(props.ticket_services) ? props.ticket_services : [])
        .map((x: any) => extractServiceId(x))
        .filter((x: any) => x !== null)
        .map((x: any) => String(x))
    );
    if (Array.isArray(props.services)) {
      selectedServices.value = props.services.filter((s: any) => {
        const sid = s?.service_id ?? s?.id;
        return s && sid !== undefined && ids.has(String(sid));
      });
    } else {
      selectedServices.value = [];
    }
  } catch (e) {
    selectedServices.value = [];
  }

  console.log("selected services in drawer", selectedServices.value);
};

const isSelected = (service: any) => {
  const sid = service?.service_id ?? service?.id;
  return (
    Array.isArray(selectedServices.value) &&
    selectedServices.value.some((s: any) => {
      const x = s?.service_id ?? s?.id;
      return x === sid;
    })
  );
};

const selectService = (service: any) => {
  if (loading.value || !service || typeof service !== "object") return;
  const sid = service?.service_id ?? service?.id;
  const exists = selectedServices.value.findIndex((s: any) => {
    const x = s?.service_id ?? s?.id;
    return x === sid;
  });
  if (exists > -1) {
    selectedServices.value.splice(exists, 1);
  } else {
    selectedServices.value.push(service);
  }
};

const goToPage = (page: number) => {
  if (page >= 1 && page <= totalPages.value) {
    currentPage.value = page;
  }
};

const nextPage = () => {
  if (currentPage.value < totalPages.value) {
    currentPage.value++;
  }
};

const prevPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
  }
};

const handleSearchChange = () => {
  if (!loading.value) {
    currentPage.value = 1;
  }
};
const showError = ref(false);
const loading = ref(false);
const handleChangeService = async () => {
  if (!selectedServices.value || selectedServices.value.length === 0) {
    showError.value = true;
    return;
  }
  try {
    loading.value = true;
    const ids = selectedServices.value
      .map((s: any) => s?.service_id ?? s?.id)
      .filter((v: any) => v !== undefined && v !== null);

    let payload = {
      services: ids.join(","),
    };

    await queueService.updateTicketService(
      props.queue_id,
      props.ticket_id,
      payload
    );
    closeThis();
    loading.value = false;

    emit("showNotification", "success", t("Teller.TicketServiceUpdatedSucess"));
    emit("reload");
  } catch (e) {
    console.log("error handle change service", e);
    loading.value = false;
  }
};

const changeService = async () => {
  if (!selectedServices.value || selectedServices.value.length === 0) {
    showError.value = true;
  } else {
    showError.value = false;
    await handleChangeService();
  }
};

//drawer width - must be defined after all reactive variables
const FixBoxWidth = computed(() => {
  return "45%";
});

watch(
  () => props.modelValue,
  (newValue) => {
    if (newValue) {
      searchQuery.value = "";
      selectedServices.value = [];
      currentPage.value = 1;
      showError.value = false;
      //delay for animation
      setTimeout(() => {
        showPopup.value = true;
        initializeSelectionFromTicket();
      }, 5);
    } else {
      showPopup.value = false;
      searchQuery.value = "";
      selectedServices.value = [];
      currentPage.value = 1;
      showError.value = false;
    }
  },
  { immediate: true }
);

watch(
  () => props.ticket_services,
  () => {
    if (showPopup.value) {
      initializeSelectionFromTicket();
    }
  },
  { deep: true }
);

onMounted(() => {
  document.addEventListener("keyup", (event) => {
    event.key === "Escape" ? closeThis() : null;
  });

  // console.log("services in drawer", props.services);
  // console.log("ticket services in drawer", props.ticket_services);
});

return (_ctx: any,_cache: any) => {
  return (__props.modelValue)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            (showPopup.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["popup-box", { 'right-class': _ctx.$i18n.locale === 'ar' }])
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                          _hoisted_6,
                          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("Teller.ChangeService")), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", {
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (closeThis())),
                          class: "close-popup"
                        }, "X")
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      (showError.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _createVNode(LbrxErrorNotification, {
                              label: _ctx.$t('Teller.PleaseSelectService'),
                              color: "#FF5757",
                              background: "rgba(255, 158, 152, 0.5)",
                              height: "6",
                              width: "100%",
                              "font-size": "0.7",
                              icon: "error-icon"
                            }, null, 8, ["label"])
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(paginatedServices).length > 0)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", _hoisted_11, [
                              _withDirectives(_createElementVNode("input", {
                                disabled: loading.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
                                type: "text",
                                placeholder: _ctx.$t('Teller.SearchService'),
                                class: "search-input",
                                onInput: handleSearchChange
                              }, null, 40, _hoisted_12), [
                                [_vModelText, searchQuery.value]
                              ])
                            ]),
                            (_unref(paginatedServices).length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paginatedServices), (service, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: service?.id || index,
                                      class: _normalizeClass(["agency-item", {
                    selected: isSelected(service),
                    disabled: loading.value,
                  }]),
                                      onClick: ($event: any) => (!loading.value && selectService(service))
                                    }, [
                                      _createElementVNode("span", null, _toDisplayString(service?.title || "Unknown Service"), 1)
                                    ], 10, _hoisted_14))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_15, [
                              _createElementVNode("button", {
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (!loading.value && prevPage())),
                                disabled: currentPage.value === 1 || loading.value,
                                class: "pagination-button"
                              }, _toDisplayString(_ctx.$t("Teller.Previous")), 9, _hoisted_16),
                              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("Teller.Page")) + " " + _toDisplayString(currentPage.value) + " " + _toDisplayString(_ctx.$t("Teller.of")) + " " + _toDisplayString(_unref(totalPages)), 1),
                              _createElementVNode("button", {
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (!loading.value && nextPage())),
                                disabled: currentPage.value === _unref(totalPages) || loading.value,
                                class: "pagination-button"
                              }, _toDisplayString(_ctx.$t("Teller.Next")), 9, _hoisted_18)
                            ])
                          ], 64))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("button", {
                          class: "btn btn-primary",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (changeService())),
                          disabled: loading.value
                        }, [
                          (loading.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t("Teller.Changing")), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_22, [
                                _hoisted_23,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("Teller.ChangeService")), 1)
                              ]))
                        ], 8, _hoisted_20),
                        _createElementVNode("button", {
                          class: "btn btn-secondary d-flex align-items-center justify-content-center gap-2",
                          disabled: loading.value,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (closeThis()))
                        }, [
                          _hoisted_25,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("Teller.Cancel")), 1)
                        ], 8, _hoisted_24)
                      ])
                    ])
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})